import React from "react";
import Project from "./projet";

export function ProjectCloed() {
  return <Project status="Cloturé" />;
}